export default class Search {
  constructor({searchButton, stayYear, stayMonth, stayDay, numDays, numPeople, numRooms} = {}) {
    this.searchButton = document.querySelector(searchButton);
    this.stayYear = document.querySelector(stayYear);
    this.stayMonth = document.querySelector(stayMonth);
    this.stayDay = document.querySelector(stayDay);
    this.numDays = document.querySelector(numDays);
    this.numPeople = document.querySelector(numPeople);
    this.numRooms = document.querySelector(numRooms);

    this.getURL = this.getURL.bind(this);

    this.init();
  }

  init() {
    if (!this.searchButton) return;
    this.bindEvents();
    this.setDate();
  }

  bindEvents() {
    this.searchButton.addEventListener('click', this.getURL);
  }

  getDate() {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    return {day, month, year};
  }

  setDate() {
    const d = this.getDate();

    this.stayYear.value = d.year;
    this.stayMonth.value = d.month;
    this.stayDay.value = d.day;
  }

  getURL() {
    let baseURL;
    let listURL;

    console.log(`${this.stayYear.value}年${this.stayMonth.value}月${this.stayDay.value}日`);
    console.log(`${this.numDays.value}泊 ${this.numPeople.value}人 ${this.numRooms.value}室`);

    // window.open(baseURL);
  }
};